module.exports = __webpack_public_path__ + "static/img/COC2023-29.d377fc0.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/meeting2023/COC2023-29.png
// module id = hLKv
// module chunks = 0